var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPostcard = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.37 42.59",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M32.19 7.89c-.74 0-1.33.6-1.33 1.33v24.12a1.33 1.33 0 1 0 2.66 0V9.22c0-.74-.6-1.33-1.33-1.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M60.96 42.59H3.42C1.53 42.59 0 41.05 0 39.17V3.42C0 1.53 1.54 0 3.42 0h57.53c1.89 0 3.42 1.54 3.42 3.42v35.75c0 1.89-1.54 3.42-3.42 3.42h.01ZM3.42 2.99c-.23 0-.42.19-.42.42v35.75c0 .23.19.42.42.42h57.53c.23 0 .42-.19.42-.42V3.42c0-.23-.19-.42-.42-.42H3.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M42.3 30.31h10.67a1.33 1.33 0 1 0 0-2.66H42.3a1.33 1.33 0 1 0 0 2.66ZM42.3 25.14h10.67a1.33 1.33 0 1 0 0-2.66H42.3a1.33 1.33 0 1 0 0 2.66ZM42.3 35.49h10.67a1.33 1.33 0 1 0 0-2.66H42.3a1.33 1.33 0 1 0 0 2.66Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.99,
    height: 7.99,
    x: 46.31,
    y: 7.09,
    fill: "#1d1d1b",
    rx: 1.12,
    ry: 1.12
  })));
};
export default SvgIconPostcard;